/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

import { IStackItemStyles } from "@fluentui/react";

export const cardStyle: IStackItemStyles = {
  root: {
    background: "#ebebeb",
    textAlign: "center",
    height: "48%",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
};

export const cardTextStyle = { fontSize: "2em", fontWeight: 400 };

export const demographicsStackItemStyle = {
  padding: "20px",
};

export const splitStackStyle = {
  width: "440px",
  height: "372px",
};

export const Line = styled.hr`
  border: 1px solid #ebebeb;
  margin: 0px 20px 0px 20px;
`;

export const InfoText = styled.span`
  color: red;
`;
